import { getAPI, type FetchResponse, type UserAPI } from '@sydle/ui-api';
import { type UIAppConfig } from '@sydle/ui-app';
import { getConfig } from '@sydle/ui-utils';
import { type BlogCategory } from '../../types/blog';
import { blogCustomAPI } from './index';

export interface GetCategoriesInput {
  appIdentifier?: string;
  lang?: string;
  hash?: string;
  size?: number;
}

export async function getCategories(input?: GetCategoriesInput): Promise<FetchResponse<BlogCategory[]>> {
  const response = await blogCustomAPI.fetch<GetCategoriesInput, BlogCategory[]>('getCategories', {
    lang: getAPI<UserAPI>('userAPI')?.getCurrentLanguage() || 'en',
    hash: window?.['SYDLE']?.app?.hash || getConfig<UIAppConfig>('ui-app')?.applicationHash,
    appIdentifier: getConfig<UIAppConfig>('ui-app')?.APPLICATION_IDENTIFIER || '',
    ...input,
  });

  return response;
}
